import {Injectable} from '@angular/core';
import {Warehouse} from '../../warehouse';
import {AbstractControl} from '@angular/forms';
import {CintacValidators} from '../../../_shared/cintac-validators';
/**
 * Created by cate on 02-11-17.
 */

@Injectable()
export class WarehouseParamsFormService {
    updateWarehouse(warehouse: Warehouse, warehouseForm: AbstractControl) {
        warehouse.frame_distance = warehouseForm.value.frame_distance;
        warehouse.total_length = warehouseForm.value.total_length;
        warehouse.support_condition_left = warehouseForm.value.support_condition_left;
        warehouse.support_condition_right = warehouseForm.value.support_condition_right;
    }

    getCommonFormErrors() {
        return {
            'frame_distance': '',
            'total_length': '',
            'support_condition_left': '',
            'support_condition_right': '',
        };
    }

    getCommonFormValidationMessages() {
        return {
            'frame_distance': {
                'required': 'Ingresar distancia entre marcos.',
                'pattern': CintacValidators.getPositiveIntegerValidatorMessage()
            },
            'total_length': {
                'required': 'Ingresar largo total.',
                'pattern': CintacValidators.getPositiveIntegerValidatorMessage()
            },
            'support_condition_left': {
                'required': 'Ingresar condición de apoyo.',
                'listValidator': CintacValidators.getSupportCondValidatorMessage()
            },
            'support_condition_right': {
                'required': 'Ingresar condición de apoyo.',
                'listValidator': CintacValidators.getSupportCondValidatorMessage()
            },
        };
    }

    updateFormMessages(form: AbstractControl, formErrors: any, validationMessages: any) {
        Object.keys(formErrors).forEach(field => {
            formErrors[field] = '';
            const control = form.get(field);
            if (control.dirty && !control.valid) {
                const messages = validationMessages[field];
                for (const key in control.errors) {
                    if (control.errors.hasOwnProperty(key)) {
                        formErrors[field] += messages[key] + ' ';
                    }
                }
            }
        });
    }

    initWarehouseDataForm(warehouseData: AbstractControl, warehouse: Warehouse) {
        warehouseData.patchValue({
            frame_distance: warehouse.frame_distance,
            total_length: warehouse.total_length,
            support_condition_left: warehouse.support_condition_left,
            support_condition_right: warehouse.support_condition_right,
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/project/project-form-components/warehouse-params-forms/warehouse-params-form.service.ts